import styled from 'styled-components';
import { color } from 'styles/pallete';

interface containerProps {
	isOpenNavBar: boolean;
}

const container = styled.div<containerProps>`
	position: relative;
	max-width: 14%;
	min-width: 250px;
	min-height: 100vh;
	max-height: 100vh;
	overflow: auto;
	background-color: ${color.interface.white};
	box-sizing: border-box;
	display: ${(props: any) => (props.isOpenNavBar ? 'flex' : 'none')};
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	padding: 1.5rem;
	z-index: 10;

	@media (max-width: 1000px) {
		position: fixed;
		top: 71px;
		left: 0;
		animation: navAnimation ease 0.2s;
	}

	@keyframes navAnimation {
		0% {
			left: -250px;
		}
		100% {
			left: 0;
		}
	}
`;

export const containerWithProps = styled(container).withConfig({
	shouldForwardProp: (prop) => !['isOpenNavBar'].includes(prop)
})``;

export const logoBox = styled.div`
	img {
		margin-top: 1.5rem;
		width: 100px;
	}
`;

export const avatarBox = styled.div`
	margin-top: 1.5rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	justify-content: center;
	align-items: center;

	p {
		font-size: 1.5rem;
		font-weight: 900;
		color: ${color.interface.lightGray};
	}

	span {
		color: ${color.interface.lightGray};
		font-size: 1.5rem;
		opacity: 0.8;
	}
`;

export const avatarBall = styled.div`
	width: 72px;
	height: 72px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	/* background-color: ${color.interface.lightGray4}; */
	border: 1.5px solid ${color.interface.lightGray4};
	margin-bottom: 0.5rem;
	cursor: pointer;

	img {
		width: 60px;
		height: 60px;
		border-radius: 50%;
	}
`;

export const toolsBox = styled.div`
	margin-top: 1.5rem;
	display: flex;
	align-items: center;
	gap: 1rem;
`;

export const optionsNavBox = styled.div`
	margin-top: 1.5rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2.5rem;

	@media (max-width: 1000px) {
		padding-bottom: 10rem;
	}
`;

export const centralizeLoad = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	@media (max-width: 1000px) {
		position: absolute;
		top: 50%;
		height: fit-content;
	}
`;
